'use strict';

$(function () {
    var createApp = Vue.createApp;
    var ref = Vue.ref;
    var computed = Vue.computed;
    var onMounted = Vue.onMounted;
    var onUnmounted = Vue.onUnmounted;

    createApp({
        setup: function setup() {
            var getMemberApi = function getMemberApi() {
                return window.NextMovingMember || null;
            };

            var member = getMemberApi();
            if (!member) {
                console.error('NextMovingMember library is not loaded.');
            }

            var session = member ? member.requireAuth('/member-login') : null;
            if (!session) {
                return {};
            }

            var orders = ref([]);
            var isLoading = ref(true);
            var errorMessage = ref('');
            var limit = ref(10);
            var offset = ref(0);
            var totalCount = ref(0);

            var initialTab = new URLSearchParams(window.location.search).get('tab') === 'saved-quotes' ? 'saved-quotes' : 'orders';
            var activeTab = ref(initialTab);
            var savedQuotes = ref([]);
            var isLoadingSavedQuotes = ref(initialTab === 'saved-quotes');

            var setActiveTab = function setActiveTab(tab) {
                activeTab.value = tab;
                try {
                    var newUrl = window.location.pathname + (tab === 'orders' ? '' : '?tab=' + tab);
                    window.history.replaceState(null, '', newUrl);
                } catch (e) {}
                if (tab === 'saved-quotes') {
                    fetchSavedQuotes();
                } else {
                    fetchOrders();
                }
            };

            var currentPage = computed(function () {
                return Math.floor(offset.value / limit.value) + 1;
            });

            var totalPages = computed(function () {
                return Math.ceil(totalCount.value / limit.value) || 1;
            });

            var fetchOrders = function fetchOrders() {
                isLoading.value = true;
                errorMessage.value = '';

                var handleResponse = function handleResponse(response) {
                    isLoading.value = false;

                    var rawData = [];
                    var total = 0;

                    if (response && Array.isArray(response.data)) {
                        rawData = response.data;
                        total = response.total !== undefined ? response.total : response.data.length;
                    } else if (Array.isArray(response)) {
                        rawData = response;
                        total = response.length;
                    }

                    totalCount.value = total;

                    var mapped = rawData.map(function (item) {
                        var quote = item.quoteNumber || item.lead && item.lead.quoteNumber || '#' + item.id;
                        var leadLocations = item.lead && Array.isArray(item.lead.locations) ? item.lead.locations : [];
                        var firstLoc = leadLocations.find(function (l) {
                            return +l.locationType === 1;
                        }) || leadLocations[0];
                        var deliveryLocs = leadLocations.filter(function (l) {
                            return +l.locationType === 2;
                        });
                        var lastLoc = deliveryLocs[deliveryLocs.length - 1] || leadLocations[leadLocations.length - 1];

                        var from = firstLoc && (firstLoc.address || firstLoc.formattedAddress) || item.lead && (item.lead.movingFrom || item.lead.pickupAddress) || item.fromAddress || '-';
                        var to = lastLoc && (lastLoc.address || lastLoc.formattedAddress) || item.lead && (item.lead.movingTo || item.lead.dropoffAddress) || item.toAddress || '-';
                        var movingDate = item.movingDate || item.date || item.lead && item.lead.movingDate || '-';

                        var totalPaid = 0;
                        if (item.payments && Array.isArray(item.payments)) {
                            item.payments.forEach(function (p) {
                                if (p.paymentType === 'refund') {
                                    totalPaid -= Number(p.amount) || 0;
                                } else {
                                    totalPaid += Number(p.amount) || 0;
                                }
                            });
                        } else if (item.depositPaid !== undefined) {
                            totalPaid = item.depositPaid;
                        }

                        var rawStatus = item.status || item.lead && item.lead.status;
                        var statusStr = 'Active';
                        if (rawStatus === 'Completed' || rawStatus === 2) {
                            statusStr = 'Completed';
                        } else if (rawStatus === 'Cancelled' || rawStatus === 'cancelled' || rawStatus === 3 || rawStatus === 0) {
                            statusStr = 'Cancelled';
                        }

                        return {
                            id: item.id,
                            quoteNumber: quote,
                            fromAddress: from,
                            toAddress: to,
                            movingDate: movingDate,
                            depositPaid: totalPaid,
                            status: statusStr,

                            fromLat: item.lead ? item.lead.movingFromLatitude : null,
                            fromLng: item.lead ? item.lead.movingFromLongitude : null,
                            toLat: item.lead ? item.lead.movingToLatitude : null,
                            toLng: item.lead ? item.lead.movingToLongitude : null,
                            propertyType: item.lead ? item.lead.isApartment ? 'Apartment / Condo' : item.lead.isHouse ? 'House' : item.lead.isOffice ? 'Office' : 'Other' : 'Apartment / Condo',
                            propertySize: item.lead ? item.lead.propertySize === 1 ? '1 Bedroom' : item.lead.propertySize === 2 ? '2 Bedroom' : item.lead.propertySize === 3 ? '3 Bedroom' : item.lead.propertySize >= 4 ? '4+ Bedroom' : 'Studio' : '2 Bedroom',
                            fullness: 'Average',
                            customer: {
                                name: item.lead && item.lead.name || session.customer.name,
                                phone: item.lead && item.lead.phone || session.phone,
                                email: item.lead && item.lead.email || session.customer.email
                            },
                            movers: item.totalMovers ? item.totalMovers + ' movers' : '2 movers',
                            instructions: item.instructions || '',
                            services: item.services || [],
                            payments: item.payments || [],
                            createdAt: item.createdAt,
                            updatedAt: item.updatedAt
                        };
                    });

                    orders.value = mapped;

                    var mappedStr = JSON.stringify(mapped);
                    if (typeof window.setCriticalData === 'function') {
                        window.setCriticalData('nextMovingMemberOrders', mappedStr);
                    } else if (window.localStorage) {
                        try {
                            localStorage.setItem('nextMovingMemberOrders', mappedStr);
                        } catch (e) {
                            console.error('Failed to write cached orders:', e);
                        }
                    }
                };

                var url = window.NEXT_MOVING_API_URL + '/reservations?sort=createdAt,DESC&limit=' + limit.value + '&offset=' + offset.value + '&join=lead&join=payments';

                $.ajax({
                    url: url,
                    type: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': 'Bearer ' + session.token
                    },
                    success: function success(response) {
                        handleResponse(response);
                    },
                    error: function error(xhr) {
                        console.error('Failed to load reservations:', xhr);
                        errorMessage.value = 'Failed to load reservations. Please try again.';
                        isLoading.value = false;
                    }
                });
            };

            var nextPage = function nextPage() {
                if (currentPage.value < totalPages.value) {
                    offset.value += limit.value;
                    fetchOrders();
                }
            };

            var prevPage = function prevPage() {
                if (offset.value > 0) {
                    offset.value = Math.max(0, offset.value - limit.value);
                    fetchOrders();
                }
            };

            var formatPrice = function formatPrice(val) {
                if (member) {
                    return member.formatPrice(val);
                }
                var num = Number(val) || 0;
                return num <= 0 ? '-' : '$' + num;
            };

            var formatDate = function formatDate(val) {
                return member ? member.formatDate(val) : val;
            };

            var getStatusClass = function getStatusClass(status) {
                return member ? member.statusClass(status) : 'is-active';
            };

            var goToOrderDetails = function goToOrderDetails(orderId) {
                if (orderId) {
                    window.location.href = '/member-order?id=' + encodeURIComponent(orderId);
                }
            };

            var isNewMoveModalOpen = ref(false);

            var openNewMoveModal = function openNewMoveModal() {
                isNewMoveModalOpen.value = true;
                document.body.classList.add('member-new-move-modal-open');

                Vue.nextTick(function () {
                    if (typeof window.initAutocomplete === 'function') {
                        window.initAutocomplete();
                    }
                    var input = document.getElementById('from-member-new-move');
                    if (input) {
                        setTimeout(function () {
                            input.focus();
                        }, 100);
                    }
                });
            };

            var closeNewMoveModal = function closeNewMoveModal() {
                isNewMoveModalOpen.value = false;
                document.body.classList.remove('member-new-move-modal-open');
            };

            var handleNewMoveSubmit = function handleNewMoveSubmit(e) {
                var form = e.target;

                var source_from = $(form).find('.from-banner').val();
                var fromLat = $(form).find('.from-banner-lat').val();
                var fromLng = $(form).find('.from-banner-lng').val();
                var fromStreet = $(form).find('.from-banner-street').val();
                var fromCity = $(form).find('.from-banner-city').val();
                var fromState = $(form).find('.from-banner-state').val();
                var fromPostalCode = $(form).find('.from-banner-postalCode').val();
                var nextStorage = $(form).find('.js-next-storage-checkbox');

                if (typeof window.setCriticalData === 'function') {
                    window.setCriticalData('home-moving-from', source_from);

                    if (fromLat) {
                        window.setCriticalData('home-moving-from-lat', fromLat);
                    }
                    if (fromLng) {
                        window.setCriticalData('home-moving-from-lng', fromLng);
                    }
                    if (fromStreet) {
                        window.setCriticalData('home-moving-from-street', fromStreet);
                    }
                    if (fromCity) {
                        window.setCriticalData('home-moving-from-city', fromCity);
                    }
                    if (fromState) {
                        window.setCriticalData('home-moving-from-state', fromState);
                    }
                    if (fromPostalCode) {
                        window.setCriticalData('home-moving-from-PostalCode', fromPostalCode);
                    }

                    if (nextStorage.is(':checked')) {
                        window.setCriticalData('next-storage', true);
                    }
                }

                window.location.href = window.location.protocol + '//' + window.location.host + '/moving-quote';
            };

            var handleGlobalKeydown = function handleGlobalKeydown(e) {
                if (e.key === 'Escape' && isNewMoveModalOpen.value) {
                    closeNewMoveModal();
                }
            };

            var standaloneServices = ref([]);

            var mapStandaloneService = function mapStandaloneService(item) {
                var label = item.serviceType && item.serviceType.name || item.label || 'Extra Service';
                var summaryParts = [];

                var optionsObj = item.options;
                if (typeof optionsObj === 'string') {
                    try {
                        optionsObj = JSON.parse(optionsObj);
                    } catch (e) {}
                }

                if (optionsObj) {
                    if (Array.isArray(optionsObj.items) && optionsObj.items.length > 0) {
                        label = 'TV Installation';
                        var tvItems = optionsObj.items.map(function (it) {
                            var sizeLabel = it.screenSize || '';
                            if (sizeLabel === 'small') sizeLabel = '32" - 49"';else if (sizeLabel === 'medium') sizeLabel = '50" - 65"';else if (sizeLabel === 'large') sizeLabel = '66" - 80"';else if (sizeLabel === 'xlarge') sizeLabel = '81" - 90"';
                            return (it.quantity || 1) + 'x ' + sizeLabel + ' TV';
                        }).join(', ');
                        summaryParts.push(tvItems);
                    }
                    if (optionsObj.wallBracket) {
                        var bracketStr = String(optionsObj.wallBracket).replace(/_/g, ' ');
                        bracketStr = bracketStr.charAt(0).toUpperCase() + bracketStr.slice(1);
                        summaryParts.push('Bracket: ' + bracketStr);
                    }
                }

                var summary = summaryParts.length > 0 ? summaryParts.join(' | ') : item.summary || '-';

                var address = optionsObj && optionsObj.location && optionsObj.location.address || item.address || item.location && item.location.address || '-';

                var serviceDate = item.date || item.scheduledDate || item.createdAt || '-';

                var totalPaid = 0;
                if (item.payments && Array.isArray(item.payments) && item.payments.length > 0) {
                    item.payments.forEach(function (p) {
                        if (p.paymentType === 'refund') {
                            totalPaid -= Number(p.amount) || 0;
                        } else {
                            totalPaid += Number(p.amount) || 0;
                        }
                    });
                } else {
                    totalPaid = Number(item.total || item.price || item.amount) || 0;
                }

                var rawStatus = item.status || 'Active';
                var statusStr = 'Active';
                if (rawStatus === 'Completed' || rawStatus === 'completed' || rawStatus === 2) {
                    statusStr = 'Completed';
                } else if (rawStatus === 'Cancelled' || rawStatus === 'cancelled' || rawStatus === 3 || rawStatus === 0) {
                    statusStr = 'Cancelled';
                }

                return {
                    id: item.id,
                    serviceNumber: item.serviceNumber || item.code || '#' + item.id,
                    type: label.toLowerCase().indexOf('tv') > -1 ? 'tv-installation' : 'extra-service',
                    label: label,
                    summary: summary,
                    address: address,
                    date: serviceDate,
                    amountPaid: totalPaid,
                    status: statusStr
                };
            };

            var fetchStandaloneServices = function fetchStandaloneServices() {
                var servicesUrl = window.NEXT_MOVING_API_URL + '/services?join=serviceType&join=payments&sort=createdAt,DESC';
                $.ajax({
                    url: servicesUrl,
                    type: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': 'Bearer ' + session.token
                    },
                    success: function success(res) {
                        var rawServices = Array.isArray(res) ? res : res && res.data ? res.data : [];
                        var unattached = rawServices.filter(function (item) {
                            return !item.reservationId && item.status !== 'cancelled';
                        });
                        standaloneServices.value = unattached.map(mapStandaloneService);
                    },
                    error: function error(xhr) {
                        console.error('Failed to fetch standalone services:', xhr);
                    }
                });
            };

            var isCancelModalOpen = ref(false);
            var cancelModalTitle = ref('Cancel Service');
            var cancelModalMessage = ref('');
            var activeServiceIdToCancel = ref('');

            var isServiceCancellationFeeApplicable = function isServiceCancellationFeeApplicable(service) {
                if (!service || !service.date || service.date === '-') {
                    return false;
                }
                try {
                    var d = new Date(service.date);
                    if (isNaN(d.getTime())) return false;
                    var now = new Date();
                    var diffHours = (d.getTime() - now.getTime()) / (1000 * 3600);
                    return diffHours < 24;
                } catch (e) {
                    return false;
                }
            };

            var cancelStandaloneService = function cancelStandaloneService(serviceId) {
                var service = (standaloneServices.value || []).find(function (item) {
                    return item.id === serviceId;
                });
                if (!service) return;

                cancelModalTitle.value = 'Cancel Service';
                activeServiceIdToCancel.value = serviceId;

                var isFeeApplicable = isServiceCancellationFeeApplicable(service);
                var feeMsg = isFeeApplicable ? 'Please note that a $59 cancellation fee will be applied in accordance with our cancellation policy.' : 'No cancellation fee will be applied in accordance with our cancellation policy.';

                cancelModalMessage.value = '<p>If you would like to reschedule your service for a different date, please call our office at (800) 433-1541, and our team will be happy to assist you.</p>' + '<p>' + feeMsg + '</p>' + '<p>Would you still like to cancel this service?</p>';

                isCancelModalOpen.value = true;
                document.body.classList.add('member-new-move-modal-open');
            };

            var closeCancelModal = function closeCancelModal() {
                isCancelModalOpen.value = false;
                document.body.classList.remove('member-new-move-modal-open');
            };

            var handleConfirmCancel = function handleConfirmCancel() {
                var serviceId = activeServiceIdToCancel.value;
                closeCancelModal();

                if (!serviceId) return;

                isLoading.value = true;
                $.ajax({
                    url: window.NEXT_MOVING_API_URL + '/services/' + encodeURIComponent(serviceId) + '/cancel',
                    type: 'POST',
                    headers: {
                        'accept': '*/*',
                        'Authorization': session && session.token ? 'Bearer ' + session.token : ''
                    },
                    success: function success(response) {
                        isLoading.value = false;
                        fetchStandaloneServices();
                    },
                    error: function error(xhr) {
                        isLoading.value = false;
                        var msg = 'Failed to cancel service. Please try again.';
                        try {
                            var parsed = JSON.parse(xhr.responseText);
                            if (parsed && parsed.message) msg = parsed.message;
                        } catch (e) {}
                        alert(msg);
                    }
                });
            };

            var handleGlobalKeydown = function handleGlobalKeydown(e) {
                if (e.key === 'Escape') {
                    if (isNewMoveModalOpen.value) {
                        closeNewMoveModal();
                    }
                    if (isCancelModalOpen.value) {
                        closeCancelModal();
                    }
                }
            };

            var isQuoteExpired = function isQuoteExpired(item) {
                var lead = item.lead || item;
                var createdAt = item.createdAt || lead && lead.createdAt || item.created_at || lead && lead.created_at;
                if (!createdAt || createdAt === '-') return false;

                var orderDate = new Date(createdAt);
                if (isNaN(orderDate.getTime())) return false;

                var difference = Date.now() - orderDate.getTime();
                var twentyFourHours = 24 * 60 * 60 * 1000;

                return difference >= twentyFourHours;
            };

            var mapSavedQuote = function mapSavedQuote(item) {
                var lead = item.lead || item;
                var quote = lead && lead.quoteNumber || item.quoteNumber || '#' + (item.id || lead && lead.id);
                var leadLocations = lead && Array.isArray(lead.locations) ? lead.locations : item.locations && Array.isArray(item.locations) ? item.locations : [];
                var firstLoc = leadLocations.find(function (l) {
                    return +l.locationType === 1;
                }) || leadLocations[0];
                var deliveryLocs = leadLocations.filter(function (l) {
                    return +l.locationType === 2;
                });
                var lastLoc = deliveryLocs[deliveryLocs.length - 1] || leadLocations[leadLocations.length - 1];

                var from = firstLoc && (firstLoc.address || firstLoc.formattedAddress) || lead && (lead.fromAddress || lead.pickupAddress) || item.fromAddress || '-';
                var to = lastLoc && (lastLoc.address || lastLoc.formattedAddress) || lead && (lead.toAddress || lead.dropoffAddress) || item.toAddress || '-';
                var movingDate = item.movingDate || lead && lead.movingDate || item.date || '-';
                var createdAt = item.createdAt || lead && lead.createdAt || item.created_at || lead && lead.created_at || '-';
                var id = item.id || lead && lead.id;

                return {
                    id: id,
                    quoteNumber: quote,
                    fromAddress: from,
                    toAddress: to,
                    movingDate: movingDate,
                    createdAt: createdAt
                };
            };

            var fetchSavedQuotes = function fetchSavedQuotes() {
                isLoadingSavedQuotes.value = true;
                $.ajax({
                    url: window.NEXT_MOVING_API_URL + '/saved-quotes',
                    type: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': 'Bearer ' + session.token
                    },
                    success: function success(res) {
                        isLoadingSavedQuotes.value = false;
                        var rawData = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
                        var validQuotes = rawData.filter(function (item) {
                            return !isQuoteExpired(item);
                        });
                        savedQuotes.value = validQuotes.map(mapSavedQuote);
                    },
                    error: function error(xhr) {
                        console.error('Failed to fetch saved quotes:', xhr);
                        isLoadingSavedQuotes.value = false;
                    }
                });
            };

            var completeReservation = function completeReservation(quoteId) {
                if (quoteId) {
                    window.location.href = '/moving-quote/?saved_quote_id=' + encodeURIComponent(quoteId);
                }
            };

            onMounted(function () {
                fetchOrders();
                fetchSavedQuotes();
                fetchStandaloneServices();
                window.addEventListener('keydown', handleGlobalKeydown);
            });

            onUnmounted(function () {
                window.removeEventListener('keydown', handleGlobalKeydown);
            });

            return {
                activeTab: activeTab,
                setActiveTab: setActiveTab,
                savedQuotes: savedQuotes,
                isLoadingSavedQuotes: isLoadingSavedQuotes,
                completeReservation: completeReservation,
                orders: orders,
                standaloneServices: standaloneServices,
                cancelStandaloneService: cancelStandaloneService,
                isCancelModalOpen: isCancelModalOpen,
                cancelModalTitle: cancelModalTitle,
                cancelModalMessage: cancelModalMessage,
                closeCancelModal: closeCancelModal,
                handleConfirmCancel: handleConfirmCancel,
                isLoading: isLoading,
                errorMessage: errorMessage,
                limit: limit,
                offset: offset,
                totalCount: totalCount,
                currentPage: currentPage,
                totalPages: totalPages,
                fetchOrders: fetchOrders,
                nextPage: nextPage,
                prevPage: prevPage,
                formatPrice: formatPrice,
                formatDate: formatDate,
                getStatusClass: getStatusClass,
                goToOrderDetails: goToOrderDetails,
                isNewMoveModalOpen: isNewMoveModalOpen,
                openNewMoveModal: openNewMoveModal,
                closeNewMoveModal: closeNewMoveModal,
                handleNewMoveSubmit: handleNewMoveSubmit
            };
        }
    }).mount('#member-area-app');
});